import { combine, isUrlAbsolute, hOP } from "@pnp/common";
import { SPRuntimeConfig } from "../config/splibconfig";
/**
 * Ensures that a given url is absolute for the current web based on context
 *
 * @param candidateUrl The url to make absolute
 *
 */
export function toAbsoluteUrl(candidateUrl) {
    return new Promise(function (resolve) {
        if (isUrlAbsolute(candidateUrl)) {
            // if we are already absolute, then just return the url
            return resolve(candidateUrl);
        }
        if (SPRuntimeConfig.baseUrl !== null) {
            // base url specified either with baseUrl of spfxContext config property
            return resolve(combine(SPRuntimeConfig.baseUrl, candidateUrl));
        }
        if (global._spPageContextInfo !== undefined) {
            // operating in classic pages
            if (hOP(global._spPageContextInfo, "webAbsoluteUrl")) {
                return resolve(combine(global._spPageContextInfo.webAbsoluteUrl, candidateUrl));
            }
            else if (hOP(global._spPageContextInfo, "webServerRelativeUrl")) {
                return resolve(combine(global._spPageContextInfo.webServerRelativeUrl, candidateUrl));
            }
        }
        // does window.location exist and have a certain path part in it?
        if (global.location !== undefined) {
            var baseUrl_1 = global.location.toString().toLowerCase();
            ["/_layouts/", "/siteassets/"].forEach(function (s) {
                var index = baseUrl_1.indexOf(s);
                if (index > 0) {
                    return resolve(combine(baseUrl_1.substr(0, index), candidateUrl));
                }
            });
        }
        return resolve(candidateUrl);
    });
}
//# sourceMappingURL=toabsoluteurl.js.map